import {
  useState,
  useEffect,
  useContext,
  useImperativeHandle,
  forwardRef,
  JSXElementConstructor, // NOSONAR : ignore
  Key, // NOSONAR : ignore
  ReactElement, // NOSONAR : ignore
  ReactNode, // NOSONAR : ignore
  ReactPortal,
  useRef, // NOSONAR : ignore
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getFormConfigDetails,
  getFormValues,
  executeAction,
  getCascadeFieldOptions,
} from "../../Helpers/APIEndpoints/Endpoints";
import { LoaderContext } from "../../Helpers/Context/Context";

import { Button, Collapse, message, Row, notification } from "antd";
import DynamicFormCase from "../DynamicFieldRenderer/DynamicFieldRenderer";
import "./DynamicForm.css";
import { API } from "../../Axios/Axios";
import dayjs from "dayjs";
import { useActionHandler } from "../ActionHandlerContext";
import { useAuthStore } from "../../AuthStore/AuthStore";
import * as AntIcons from "@ant-design/icons";
import { ApiStatus, ErrorCodes } from "../../Enum/ApiStatusEnum";

const { Panel } = Collapse;
const DynamicFormComponent = forwardRef(({ ...props }: any, ref) => {
  const location = useLocation();
  const { state } = location || {};
  const [formData, setFormData] = useState<any>(null);
  const [form] = useState<any>(props?.form);
  const [activeTab] = useState<any>(props?.activeTab ?? null);
  const [setIsReset] = useState(false);
  const [actionType] = useState(state?.actionType ?? props?.actionType ?? null);
  const [formSections, setFormSections] = useState(props?.formSections ?? null);
  const [RId] = useState(state?.RId ?? props?.RId ?? 0);
  const [interfaceId, setInterfaceId] = useState<number>(
    state?.id ?? props?.id ?? 0,
  );
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [gridData, setGridData] = useState<Record<string, any>>([]);
  const [editablegridData, setEditableGridData] = useState<Record<string, any>>(
    [],
  ); // NOSONAR : ignore
  const [mode] = useState(state?.Mode ?? props?.Mode);
  const [fetchFormData, setFetchFormData] = useState<any>();
  const [buttonLoadings, setButtonLoadings] = useState<Record<string, boolean>>(
    {},
  );
  const [fetchedEditData, setFetchedEditData] = useState<any>({});
  const { interfaceActionHandler, interfaceFieldActionHandler } =
    useActionHandler();
  const { commonContextParams } = useAuthStore();
  const [DocName, setDocName] = useState({});
  const [initialMaskValue, setInitialMaskValue] = useState<any>({});
  const [resetUpload, setResetUpload] = useState(0);

  let formConfig: any = null;
  const formReadyCalled = useRef(false);

  const navigate = useNavigate();

  const visibilityRef = useRef<Array<{ fieldName: string; updates: any }>>([]);

  const hideField = (
    content: Array<{ name: string; isFieldVisible?: boolean }>,
    fieldName: string,
  ) => {
    return content.map((item) =>
      item.name === fieldName ? { ...item, isFieldVisible: false } : item,
    );
  };

  const showField = async (
    content: Array<{ name: string; isFieldVisible?: boolean }>,
    fieldName: string,
  ) => {
    return content.map((item) =>
      item.name === fieldName ? { ...item, isFieldVisible: true } : item,
    );
  };

  //Added By Vishrant to handle disable field in form sections
  const DisableField = (
    content: Array<{ name: string; isFieldDisable?: boolean }>,
    fieldName: string,
  ) => {
    return content.map((item) =>
      item.name === fieldName ? { ...item, isFieldDisable: true } : item,
    );
  };

  //Added By Vishrant to handle enable field in form sections
  const EnableField = (
    content: Array<{ name: string; isFieldDisable?: boolean }>,
    fieldName: string,
  ) => {
    return content.map((item) =>
      item.name === fieldName ? { ...item, isFieldDisable: false } : item,
    );
  };

  const hideFields = async (
    content: Array<{ name: string; isFieldVisible?: boolean }>,
    fieldName: Array<string>,
  ) => {
    return content.map((item) =>
      fieldName?.includes(item?.name)
        ? { ...item, isFieldVisible: false }
        : { ...item, isFieldVisible: true },
    );
  };

  const showFields = async (
    content: Array<{ name: string; isFieldVisible?: boolean }>,
    fieldName: Array<string>,
  ) => {
    return content.map((item) =>
      fieldName?.includes(item?.name)
        ? { ...item, isFieldVisible: true }
        : item,
    );
  };

  const enableField = async (
    content: Array<{ name: string; isFieldVisible?: boolean }>,
    fieldName: string,
  ) => {
    return content.map((item) =>
      item.name === fieldName ? { ...item, isFieldDisable: false } : item,
    );
  };

  const disableField = async (
    content: Array<{ name: string; isFieldVisible?: boolean }>,
    fieldName: string,
  ) => {
    return content.map((item) =>
      item.name === fieldName ? { ...item, isFieldDisable: true } : item,
    );
  };

  const enableFields = async (
    content: Array<{ name: string; isFieldVisible?: boolean }>,
    fieldName: Array<string>,
  ) => {
    return content.map((item) =>
      fieldName?.includes(item?.name)
        ? { ...item, isFieldDisable: false }
        : item,
    );
  };

  const disableFields = async (
    content: Array<{ name: string; isFieldVisible?: boolean }>,
    fieldName: Array<string>,
  ) => {
    return content.map((item) =>
      fieldName?.includes(item?.name)
        ? { ...item, isFieldDisable: true }
        : item,
    );
  };

  const UpdateMultipleFieldMandatoryRule = (
    content: Array<{
      rules: any;
      name: string;
      isFieldVisible?: boolean;
    }>,
    fieldsArray: Array<{ fieldName: string; value: boolean }>,
  ) => {
    fieldsArray.forEach((fa) => {
      const updatedRequiredRule = [{ required: fa.value }];
      return content.map((item) =>
        item.name === fa.fieldName
          ? {
            ...item,
            rules:
              item.rules && item.rules.length > 0
                ? modifyRules(item.rules, fa.value)
                : updatedRequiredRule,
          }
          : item,
      );
    });
  };

  const UpdateFieldMandatoryRule = (
    content: Array<{
      rules: any;
      name: string;
      isFieldVisible?: boolean;
    }>,
    fieldName: string,
    flag: boolean,
  ) => {
    const updatedRequiredRule = [{ required: flag }];
    return content.map((item) =>
      item.name === fieldName
        ? {
          ...item,
          rules:
            item.rules && item.rules.length > 0
              ? modifyRules(item.rules, flag)
              : updatedRequiredRule,
        }
        : item,
    );
  };

  const modifyRules = (rules: any, flag: boolean) => {
    console.log("modify rules called");
    console.log(rules);
    const updatedArray = rules.map((item: any, index: number) =>
      index === 0 ? { ...item, required: flag } : item,
    );
    console.log(updatedArray);
    return updatedArray;
  };

  ////Added By Vishrant
  // useEffect(() => {
  //   if (formSections !== null) {
  //     props?.onFormReady?.();
  //   }
  //   // if (props.ref?.current) {
  //   //   props?.onFormReady?.();
  //   //   //dynamicFormRef.current.disableField("Initiator");
  //   // }
  // }, [formSections]);

  // useEffect(() => {
  //   if (
  //     !formReadyCalled.current &&
  //     typeof interfaceActionHandler?.handleFormReady === "function" &&
  //     formSections?.length > 0
  //   ) {
  //     formReadyCalled.current = true;

  //     interfaceActionHandler["handleFormReady"]();
  //   }
  // }, [formSections]);

  useEffect(() => {
    if (
      !formReadyCalled.current &&
      typeof interfaceActionHandler?.handleFormReady === "function" &&
      (
        (mode === "Create" && formSections) ||
        (mode === "Edit" && fetchFormData)
      )
    ) {
      formReadyCalled.current = true;

      // wait one tick so AntD applies setFieldValue
      setTimeout(() => {
        interfaceActionHandler.handleFormReady(form.getFieldsValue(), RId);
      }, 0);
    }
  }, [fetchFormData, formSections]);

  // useEffect(() => {
  //   if (
  //     mode === "Edit" &&
  //     fetchFormData &&
  //     form &&
  //     typeof form.getFieldsValue === "function"
  //   ) {
  //     // slight delay ensures AntD applied values
  //     setTimeout(() => {
  //       interfaceFieldActionHandler?.handleRoleChange?.(form);
  //     }, 0);
  //   }
  // }, [fetchFormData]);

  // useEffect(() => {
  //   if (!formSections || !visibilityRef.current.length) return;

  //   setFormSections((prev: any) =>
  //     prev?.map((section: any) => ({
  //       ...section,
  //       content: section.content.map((field: any) => {
  //         const match = visibilityRef.current.find(
  //           (u) => u.fieldName === field.name
  //         );
  //         return match ? { ...field, ...match.updates } : field;
  //       }),
  //     }))
  //   );
  // }, [formSections]);

  const mapFormCascadeOptions = async (apiOne: any, apiTwo: any) => {
    // NOSONAR : ignore
    for (const tab of apiOne) {
      for (const section of tab.section) {
        for (const field of section.content) {
          // Find the matching object in apiTwo based on placeHolderId
          const matchedEntry = apiTwo?.find(
            (entry: any) => entry.placeHolderId === field.placeHolderId,
          );

          if (matchedEntry && matchedEntry.data[field.name] !== undefined) {
            if (field.lazyload) {
              let fieldOptions = await getCascadeOptions(
                field,
                matchedEntry.data,
              );

              if (fieldOptions.length > 0) {
                field.fieldOptions = fieldOptions;
              }
            }
          }
        }
      }
    }
  };

  const mapFormCascadeOptionsNonAuthConfig = async (
    apiOne: any,
    apiTwo: any,
  ) => {
    // NOSONAR : ignore
    for (const Tab of apiOne) {
      for (const section of Tab.section) {
        if (section?.header !== "ActionConfig") {
          for (const field of section.content) {
            // Find the matching object in apiTwo based on placeHolderId
            const matchedEntry = apiTwo?.find(
              (entry: any) => entry.placeHolderId === field.placeHolderId,
            );

            if (matchedEntry && matchedEntry.data[field.name] !== undefined) {
              if (field.lazyload) {
                let fieldOptions = await getCascadeOptions(
                  field,
                  matchedEntry.data,
                );

                if (fieldOptions.length > 0) {
                  field.fieldOptions = fieldOptions;
                }
              }
            }
          }
        }
      }
    }
  };

  useImperativeHandle(ref, () => ({
    hideField: (fieldName: string) => {
      setFormSections((prev: any[]) =>
        prev.map(async (fs) =>
          fs.header !== "ActionConfig"
            ? {
              ...fs,
              content: await hideField(fs.content, fieldName),
            }
            : fs,
        ),
      );
    },
    showField: (fieldName: string) => {
      setFormSections((prev: any[]) =>
        prev.map(async (fs) =>
          fs.header !== "ActionConfig"
            ? {
              ...fs,
              content: await showField(fs.content, fieldName),
            }
            : fs,
        ),
      );
    },
    hideFields: (fieldName: any) => {
      setFormSections((prev: any[]) =>
        prev.map(async (fs) =>
          fs.header !== "ActionConfig"
            ? {
              ...fs,
              content: await hideFields(fs.content, fieldName),
            }
            : fs,
        ),
      );
    },
    showFields: (fieldName: any) => {
      setFormSections((prev: any[]) =>
        prev.map(async (fs) =>
          fs.header !== "ActionConfig"
            ? {
              ...fs,
              content: await showFields(fs.content, fieldName),
            }
            : fs,
        ),
      );
    },
    setValue: (fieldName: any, value: any) => {
      form.setFieldsValue({ [fieldName]: value });
    },
    setMaskedValue(field: string, value: string) {
      setInitialMaskValue((prev: any) => ({
        ...prev,
        [field]: value,
      }));
    },
    setFieldOptions: (fieldName: any, option: any) => {
      const updatedSections = formSections.map(
        (fs: { content: any[]; header: string }) => {
          if (fs.header !== "ActionConfig") {
            // Deep clone content to avoid mutating original
            // const updatedContent = fs.content.map((f: { name: string }) => {
            //   if (fieldName.some((x: any) => x === f.name)) {
            //     let index = fieldName.findIndex((x: any) => x === f.name);
            //     let existingoptions = [...f.fieldOptions, ...option];
            //     return {
            //       ...f,
            //       fieldOptions: index !== -1 ? existingoptions : f.fieldOptions,
            //     };
            //   }
            //   return f;
            // });
            const updatedContent = hideField(fs.content, fieldName);
            return {
              ...fs,
              content: updatedContent,
            };
          }

          return fs;
        },
      );

      setFormSections(updatedSections);
    },
    disableField: (fieldName: string) => {
      setFormSections((prev: any[]) =>
        prev.map(async (fs) =>
          fs.header !== "ActionConfig"
            ? {
              ...fs,
              content: await disableField(fs.content, fieldName),
            }
            : fs,
        ),
      );
    },
    enableField: (fieldName: string) => {
      setFormSections((prev: any[]) =>
        prev.map(async (fs) =>
          fs.header !== "ActionConfig"
            ? {
              ...fs,
              content: await enableField(fs.content, fieldName),
            }
            : fs,
        ),
      );
    },
    disableFields: (fieldName: Array<string>) => {
      setFormSections((prev: any[]) =>
        prev.map(async (fs) =>
          fs.header !== "ActionConfig"
            ? {
              ...fs,
              content: await disableFields(fs.content, fieldName),
            }
            : fs,
        ),
      );
    },
    enableFields: (fieldName: Array<string>) => {
      setFormSections((prev: any[]) =>
        prev.map(async (fs) =>
          fs.header !== "ActionConfig"
            ? {
              ...fs,
              content: await enableFields(fs.content, fieldName),
            }
            : fs,
        ),
      );
    },
    UpdateFieldMandatoryRule: (fieldName: string, flag: boolean) => {
      setFormSections((prev: any[]) =>
        prev.map((fs) =>
          fs.header !== "ActionConfig"
            ? {
              ...fs,
              content: UpdateFieldMandatoryRule(fs.content, fieldName, flag),
            }
            : fs,
        ),
      );
    },
    UpdateMultipleFieldMandatoryRule: (
      fieldsArray: Array<{ fieldName: string; value: boolean }>,
    ) => {
      setFormSections((prev: any[]) =>
        prev.map((fs) =>
          fs.header !== "ActionConfig"
            ? {
              ...fs,
              content: UpdateMultipleFieldMandatoryRule(
                fs.content,
                fieldsArray,
              ),
            }
            : fs,
        ),
      );
    },

    // setFieldVisibility: (updates: any) => {
    //   visibilityRef.current = updates; // ⭐ store latest rules

    //   setFormSections((prev: any) =>
    //     prev?.map((section: any) => ({
    //       ...section,
    //       content: section.content.map((field: any) => {
    //         const match = updates.find((u: any) => u.fieldName === field.name);
    //         return match ? { ...field, ...match.updates } : field;
    //       }),
    //     }))
    //   );
    // },

    setFieldVisibility: (updates: { fieldName: string; updates: any }[]) => {
      setFormSections((prev: any[]) =>
        prev?.map((section: { header: string; content: any[] }) => {
         //// if (section.header === "ActionConfig") return section;

          return {
            ...section,
            content: section.content.map((field: { name: string }) => {
              const match = updates.find((u) => u.fieldName === field.name);

              return match ? { ...field, ...match.updates } : { ...field };
            }),
          };
        }),
      );
    },
  }));

  // useImperativeHandle(ref, () => ({
  //   hideFields: (fieldName: string) => {
  //     setFormSections((prev: any[]) =>
  //       prev?.map((fs) =>
  //         fs.header !== "ActionConfig"
  //           ? {
  //             ...fs,
  //             content: fs.content.map((f: { name: string }) =>
  //               f.name === fieldName ? { ...f, isFieldVisible: false } : f,
  //             ),
  //           }
  //           : fs,
  //       ),
  //     );
  //   },

  //   showFields: (fieldName: string) => {
  //     setFormSections((prev: any[]) =>
  //       prev?.map((fs) =>
  //         fs.header !== "ActionConfig"
  //           ? {
  //             ...fs,
  //             content: fs.content.map((f: { name: string }) =>
  //               f.name === fieldName ? { ...f, isFieldVisible: true } : f,
  //             ),
  //           }
  //           : fs,
  //       ),
  //     );
  //   },

  //   disableField: (fieldName: string) => {
  //     setFormSections((prev: any[]) =>
  //       prev?.map((fs) =>
  //         fs.header !== "ActionConfig"
  //           ? {
  //             ...fs,
  //             content: fs.content.map((f: { name: string }) =>
  //               f.name === fieldName ? { ...f, isFieldDisable: true } : f,
  //             ),
  //           }
  //           : fs,
  //       ),
  //     );
  //   },

  //   enableField: (fieldName: string) => {
  //     setFormSections((prev: any[]) =>
  //       prev?.map((fs) =>
  //         fs.header !== "ActionConfig"
  //           ? {
  //             ...fs,
  //             content: fs.content.map((f: { name: string }) =>
  //               f.name === fieldName ? { ...f, isFieldDisable: false } : f,
  //             ),
  //           }
  //           : fs,
  //       ),
  //     );
  //   },

  //   setValue: (fieldName: string, value: any) => {
  //     form.setFieldsValue({ [fieldName]: value });
  //   },
  //   setMaskedValue(field: string, value: string) {
  //     setInitialMaskValue((prev: any) => ({
  //       ...prev,
  //       [field]: value,
  //     }));
  //   },
  //   setFieldOptions: (fieldName: any, option: any) => {
  //     const updatedSections = formSections.map(
  //       (fs: { content: any[]; header: string }) => {
  //         if (fs.header !== "ActionConfig") {
  //           // Deep clone content to avoid mutating original
  //           // const updatedContent = fs.content.map((f: { name: string }) => {
  //           //   if (fieldName.some((x: any) => x === f.name)) {
  //           //     let index = fieldName.findIndex((x: any) => x === f.name);
  //           //     let existingoptions = [...f.fieldOptions, ...option];
  //           //     return {
  //           //       ...f,
  //           //       fieldOptions: index !== -1 ? existingoptions : f.fieldOptions,
  //           //     };
  //           //   }
  //           //   return f;
  //           // });
  //           const updatedContent = hideFields(fs.content, fieldName);
  //           return {
  //             ...fs,
  //             content: updatedContent,
  //           };
  //         }

  //         return fs;
  //       },
  //     );

  //     setFormSections(updatedSections);
  //   },
  //   CustomMultiFieldsConfiguration: (
  //     disablefieldName: Array<string>,
  //     enablefieldName: Array<string>,
  //     hidefieldName: Array<string>,
  //     showfieldName: Array<string>,
  //   ) => {
  //     const updatedSections = formSections.map(
  //       (fs: { content: any[]; header: string }) => {
  //         if (fs.header !== "ActionConfig") {
  //           let updatedContent = enableFields(fs.content, enablefieldName);
  //           updatedContent = disableFields(updatedContent, disablefieldName);
  //           updatedContent = hideFields(updatedContent, hidefieldName);
  //           updatedContent = showFields(updatedContent, showfieldName);
  //           return {
  //             ...fs,
  //             content: updatedContent,
  //           };
  //         }

  //         return fs;
  //       },
  //     );

  //     setFormSections(updatedSections);
  //   },
  //       UpdateFieldMandatoryRule: (fieldName: string, flag: boolean) => {
  //     setFormSections((prev: any[]) =>
  //       prev.map((fs) =>
  //         fs.header !== "ActionConfig"
  //           ? {
  //               ...fs,
  //               content: UpdateFieldMandatoryRule(fs.content, fieldName, flag),
  //             }
  //           : fs,
  //       ),
  //     );
  //   },
  //   UpdateMultipleFieldMandatoryRule: (
  //     fieldsArray: Array<{ fieldName: string; value: boolean }>,
  //   ) => {
  //     setFormSections((prev: any[]) =>
  //       prev.map((fs) =>
  //         fs.header !== "ActionConfig"
  //           ? {
  //               ...fs,
  //               content: UpdateMultipleFieldMandatoryRule(
  //                 fs.content,
  //                 fieldsArray,
  //               ),
  //             }
  //           : fs,
  //       ),
  //     );
  //   },
  //   setFieldVisibility: (updates: { fieldName: string; updates: any }[]) => {
  //     setFormSections((prev: any[]) =>
  //       prev?.map((section: { header: string; content: any[] }) => {
  //         if (section.header === "ActionConfig") return section;

  //         return {
  //           ...section,
  //           content: section.content.map((field: { name: string }) => {
  //             const match = updates.find((u) => u.fieldName === field.name);

  //             return match ? { ...field, ...match.updates } : { ...field };
  //           }),
  //         };
  //       }),
  //     );
  //   },
  // }));


  // useImperativeHandle(ref, () => ({
  //   hideFields: (fieldName: any) => {
  //     const updatedSections = formSections.map(
  //       (fs: { content: any[]; header: string }) => {
  //         if (fs.header !== "ActionConfig") {
  //           // Deep clone content to avoid mutating original
  //           // const updatedContent = fs.content.map((f: { name: string }) => {
  //           //   if (f.name === fieldName) {
  //           //     return {
  //           //       ...f,
  //           //       isFieldVisible: false,
  //           //     };
  //           //   }
  //           //   return f;
  //           // });
  //           const updatedContent = hideFields(fs.content, fieldName);
  //           return {
  //             ...fs,
  //             content: updatedContent,
  //           };
  //         }

  //         return fs;
  //       },
  //     );

  //     setFormSections(updatedSections);
  //   },
  //   showFields: (fieldName: any) => {
  //     const updatedSections = formSections.map(
  //       (fs: { content: any[]; header: string }) => {
  //         if (fs.header !== "ActionConfig") {
  //           // Deep clone content to avoid mutating original
  //           // const updatedContent = fs.content.map((f: { name: string }) => {
  //           //   if (f.name === fieldName) {
  //           //     return {
  //           //       ...f,
  //           //       isFieldVisible: true,
  //           //     };
  //           //   }
  //           //   return f;
  //           // });

  //           ////Added By Vishrant to handle show field in form sections
  //           //const updatedContent = hideField(fs.content, fieldName);
  //           const updatedContent = showFields(fs.content, fieldName);
  //           return {
  //             ...fs,
  //             content: updatedContent,
  //           };
  //         }

  //         return fs;
  //       },
  //     );

  //     setFormSections(updatedSections);
  //   },
  //   setValue: (fieldName: any, value: any) => {
  //     form.setFieldsValue({ [fieldName]: value });
  //   },
  //   setMaskedValue(field: string, value: string) {
  //     setInitialMaskValue((prev: any) => ({
  //       ...prev,
  //       [field]: value,
  //     }));
  //   },
  //   disableField: (fieldName: any) => {
  //     const updatedSections = formSections.map(
  //       (fs: { content: any[]; header: string }) => {
  //         if (fs.header !== "ActionConfig") {
  //           // Deep clone content to avoid mutating original
  //           // const updatedContent = fs.content.map((f: { name: string }) => {
  //           //   if (f.name === fieldName) {
  //           //     return {
  //           //       ...f,
  //           //       isFieldDisable: true,
  //           //     };
  //           //   }
  //           //   return f;
  //           // });

  //           ////Added By Vishrant to handle disable field in form sections
  //           //const updatedContent = hideField(fs.content, fieldName);
  //           const updatedContent = DisableField(fs.content, fieldName);
  //           return {
  //             ...fs,
  //             content: updatedContent,
  //           };
  //         }

  //         return fs;
  //       },
  //     );

  //     setFormSections(updatedSections);
  //   },
  //   setFieldOptions: (fieldName: any, option: any) => {
  //     const updatedSections = formSections.map(
  //       (fs: { content: any[]; header: string }) => {
  //         if (fs.header !== "ActionConfig") {
  //           // Deep clone content to avoid mutating original
  //           // const updatedContent = fs.content.map((f: { name: string }) => {
  //           //   if (fieldName.some((x: any) => x === f.name)) {
  //           //     let index = fieldName.findIndex((x: any) => x === f.name);
  //           //     let existingoptions = [...f.fieldOptions, ...option];
  //           //     return {
  //           //       ...f,
  //           //       fieldOptions: index !== -1 ? existingoptions : f.fieldOptions,
  //           //     };
  //           //   }
  //           //   return f;
  //           // });
  //           const updatedContent = hideFields(fs.content, fieldName);
  //           return {
  //             ...fs,
  //             content: updatedContent,
  //           };
  //         }

  //         return fs;
  //       },
  //     );

  //     setFormSections(updatedSections);
  //   },
  //   enableField: (fieldName: any) => {
  //     const updatedSections = formSections.map(
  //       (fs: { content: any[]; header: string }) => {
  //         if (fs.header !== "ActionConfig") {
  //           // Deep clone content to avoid mutating original
  //           // const updatedContent = fs.content.map((f: { name: string }) => {
  //           //   if (f.name === fieldName) {
  //           //     return {
  //           //       ...f,
  //           //       isFieldDisable: false,
  //           //     };
  //           //   }
  //           //   return f;
  //           // });

  //           ////Added By Vishrant to handle enable field in form sections
  //           //const updatedContent = hideField(fs.content, fieldName);
  //           const updatedContent = EnableField(fs.content, fieldName);
  //           return {
  //             ...fs,
  //             content: updatedContent,
  //           };
  //         }

  //         return fs;
  //       },
  //     );

  //     setFormSections(updatedSections);
  //   },
  // }));

  useEffect(() => {
    if (
      !state?.id &&
      !props?.id &&
      !state?.actionType &&
      !props?.actionType &&
      !state?.RId &&
      !props?.RId
    ) {
      return;
    }

    setInterfaceId(state?.id ?? props?.id ?? 0);
  });

  let getcurrentTabData = async () => {
    return new Promise((resolve, reject) => {
      API.post(getFormConfigDetails, {
        InterfaceId: interfaceId,
        TabId: parseInt(activeTab) || 0,
        Mode: mode,
        RoleId: commonContextParams?.roleId,
        FormData: "", //Added by Vishrant (Dropdown options are not coming in edit mode because of this, need to check with backend team regarding this)
      })
        .then((response) => {
          if (response && !response.status) {
            throw new Error("Failed to fetch data");
          }
          return response;
        })
        .then((data) => resolve(data))
        .catch((error) => {
          console.error("Error fetching tab data:", error);
          reject(new Error("Error fetching tab data"));
        });
    });
  };

  useEffect(() => {
    if (activeTab) {
      const activeDataSectionsExists =
        (formData?.data?.[parseInt(activeTab)]?.section?.length ?? 0) > 0;
      if (!activeDataSectionsExists) {
        getcurrentTabData().then((formConfigResponse: any) => {
          // NOSONAR : ignore
          if (
            formConfigResponse.data &&
            formConfigResponse.data?.data?.length > 0
          ) {
            formConfig = formConfigResponse.data;

            let dynamicFormData = formData;
            if (dynamicFormData) {
              for (
                let index = 0;
                index < dynamicFormData?.data?.length;
                index++
              ) {
                let data = dynamicFormData.data;
                data[index] ??= {}; // Initialize if not already defined

                if (
                  formConfig.data.some(
                    (x: { tabId: { toString: () => any } }) =>
                      x.tabId.toString() === data[index]?.TabId?.toString(),
                  )
                ) {
                  dynamicFormData.data[index].section = formConfig.data.find(
                    (x: { tabId: { toString: () => any } }) =>
                      x.tabId.toString() === data[index]?.TabId?.toString(),
                  )?.section;
                }
              }
            } else {
              dynamicFormData = formConfigResponse.data;
            }

            let tabSections = dynamicFormData.data.find(
              (x: { tabId: { toString: () => any } }) =>
                x.tabId.toString() === activeTab.toString(),
            );
            if (tabSections) {
              setFormSections(tabSections.section);
            } else {
              setFormSections(null);
            }
          }

          if (mode === "Edit" || mode === "View") {
            FetchFormDataAPI().then((formValues) => {
              const updateFormValues = async () => {
                // NOSONAR : ignore
                if (formConfig.data && formValues) {
                  await mapFormCascadeOptions(formConfig.data, formValues); // Ensure all async calls finish
                }
                setFetchFormData(formValues); // Now update the form
              };

              updateFormValues();
            });
            setFormData(formConfigResponse);
          }
        });
      }
    } else {
      getFormConfig();
    }
  }, [activeTab, interfaceId]);

  useEffect(() => {
    const mapFormValues = async () => {
      // NOSONAR : ignore
      const formValues: Record<string, any> = {};

      // store all the values fetched in the state to use it later
      if (fetchFormData) {
        for (const fd of fetchFormData) {
          console.log(fd.data);
          setFetchedEditData((prev: any) => ({
            ...prev,
            ...fd.data,
          }));
        }
      }
      if (formData?.data?.data && formData?.data?.data.length > 0) {
        console.log("Form data 415", formData.data.data);
        for (const tab of formData?.data?.data ?? []) {
          for (const section of tab.section ?? []) {
            if (section !== "ActionConfig") {
              for (const field of section?.content ?? []) {
                // Find the matching object in apiTwo based on placeHolderId
                const matchedEntry = fetchFormData?.find(
                  (entry: any) => entry.placeHolderId === field.placeHolderId,
                );

                if (
                  matchedEntry &&
                  matchedEntry.data[field.name] !== undefined
                ) {
                  const matchedValue = matchedEntry.data[field.name];

                  // set form values according to field type
                  if (field.inputType === "Checkbox") {
                    formValues[field.name] = matchedValue === "1";
                  } else if (field.inputType === "Select") {
                    const selectedOption = field.fieldOptions?.find(
                      (option: any) =>
                        option.value.toString() === matchedValue?.toString(),
                    );

                    formValues[field.name] = selectedOption
                      ? selectedOption.value.toString()
                      : matchedValue?.toString();
                  } else if (field.inputType.toLowerCase() === "selectmulti") {
                    formValues[field.name] = matchedValue
                      ?.toString()
                      ?.split(",")
                      ?.map((val: any) => val.trim());
                  } else if (field.inputType === "Date") {
                    formValues[field.name] = matchedValue
                      ? dayjs(matchedValue)
                      : null;
                  } else if (field.name === "EvaluationForm") {
                    let jsonResult = await interfaceActionHandler["CreateJson"](
                      formValues,
                      field.name,
                      [
                        "InterpersonalSkills1",
                        "InterpersonalSkills2",
                        "PracticalSkills1",
                        "PracticalSkills2",
                      ],
                    );

                    formValues["EvaluationForm"] = matchedValue
                      ? jsonResult.EvaluationForm
                      : null;
                  }

                  // NOSONAR : TODO Masking
                  // else if (field.masked === "true") {
                  //   formValues[field.name] = await interfaceFieldActionHandler[
                  //     "showQuickAddModal"
                  //   ](field.name, matchedValue, true);
                  //   setInitialMaskValue((prev: any) => ({
                  //     ...prev,
                  //     [field.name]: matchedValue,
                  //   }));
                  // }
                  else if (field.inputType === "File") {
                    setDocName((prev) => ({
                      ...prev,
                      [field.name]: matchedValue,
                    }));
                  } else if (field.inputType === "FieldSet") {
                    setGridData((prev) => ({
                      ...prev,
                      [field.name]: matchedValue
                        ? JSON.parse(matchedValue)
                        : null,
                    }));
                  } else if (field.inputType === "EditableFieldSet") {
                    setEditableGridData((prev) => ({
                      ...prev,
                      [field.name]: matchedValue
                        ? JSON.parse(matchedValue)
                        : null,
                    }));
                  } else if (field.rules && field.rules[0]?.type === "number") {
                    formValues[field.name] = matchedValue
                      ? Number(matchedValue)
                      : null;
                  } else if (field.inputType?.toLowerCase() === "custom") {
                    let jsonResult = await interfaceActionHandler[
                      "customJsonMethod"
                    ](formValues, field.name);

                    formValues[field.name] = jsonResult;
                  } else {
                    formValues[field.name] = matchedValue;
                  }

                  //This will trigger on change function for edit screen
                  if (field.onChange &&
                    interfaceFieldActionHandler[field.onChange]) {
                    await interfaceFieldActionHandler[field.onChange](
                      formValues,
                    );
                  }

                  // Set form value for each field
                  if (field.inputType !== "File") {
                    form?.setFieldValue(field.name, formValues[field.name]);
                  }
                }
              }
            }
          }
        }
      }

      return formValues;
    };

    mapFormValues();
  }, [fetchFormData]);

  const handleMaskValueChange = (key, val) => {
    setInitialMaskValue((prev: any) => ({
      ...prev,
      [key]: val,
    }));
  };

  // Function to fetch dependent dropdown data
  const fetchDropdownData = async (
    fieldId: string,
    execParams: any[],
  ): Promise<any[]> => {
    try {
      await showLoader();
      // Transform execParams in-place
      Object.keys(execParams).forEach((key: any) => {
        if (Array.isArray(execParams[key])) {
          execParams[key] = execParams[key].join(",");
        }
      });

      const response = await API.post(getCascadeFieldOptions, {
        FieldId: fieldId,
        interfaceId,
        FormData: JSON.stringify(execParams),
      });

      if (response && !response.status) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.data.data; // Parse and return the JSON response
    } catch (error) {
      console.error(`Error fetching data for ${fieldId}:`, error);
      return []; // Return an empty array in case of an error
    } finally {
      await hideLoader();
    }
  };

  const getCascadeOptions = async (
    currentField: any,
    data: any,
  ): Promise<any[]> => {
    if (!currentField) return [];

    if (currentField.lazyload) {
      // Validate required execution parameters
      let hasError = false;
      const execParamsList = (currentField.execParams ?? []).reduce(
        (acc: { [x: string]: any }, param: { name: string | number }) => {
          const paramValue = data[param.name] ?? "";

          if (paramValue === "") {
            hasError = true;
            acc[param.name] = `${param.name} is required`; // Store error message
          } else {
            acc[param.name] = paramValue;
          }
          return acc;
        },
        {},
      );

      // Stop execution if validation fails and show specific error messages in dropdown
      if (hasError) {
        currentField.fieldOptions = Object.values(execParamsList)
          .filter((msg) => (msg as string).includes("is required")) // Show only required errors
          .map((msg) => ({ label: msg as string, value: "" }));

        return currentField.fieldOptions;
      }

      try {
        const response = await fetchDropdownData(
          currentField.Id,
          execParamsList,
        );

        return response;
      } catch (error) {
        console.error(`Failed to load data for ${currentField.name}:`, error);
      }
      return [];
    }
    return [];
  };

  //Get config from backend
  const getFormConfig = async () => {
    try {
      await showLoader();

      let dynamicFormData: any;

      let formConfigResponse = await API.post(getFormConfigDetails, {
        InterfaceId: interfaceId,
        TabId: activeTab ?? 0,
        Mode: mode ?? "Create",
        FieldIds: "",
        FormData: "",
        ActionType: "",
        SearchString: "",
        RoleId: commonContextParams?.roleId,
      });

      if (formConfigResponse.data && formConfigResponse.data.data?.length > 0) {
        formConfig = formConfigResponse;

        if (dynamicFormData) {
          for (let index = 0; index < dynamicFormData.data.length; index++) {
            let data = dynamicFormData.data;
            data[index] ??= {}; // Initialize if not already defined

            dynamicFormData.data[index].section =
              formConfig.data.find(
                (x: { tabId: { toString: () => any } }) =>
                  x.tabId.toString() === data[index]?.TabId?.toString(),
              )?.section ?? {}; // Assign a default object if no match is found
          }
        }

        if (activeTab) {
          setFormSections(formConfigResponse.data.data[0].section);
        } else if (formConfigResponse.data?.data[0]?.section?.length > 0) {
          setFormSections(formConfigResponse.data.data[0].section);
        } else {
          setFormSections(formConfigResponse.data.data);
        }

        if (mode === "Edit" || mode === "View") {
          let formValues = await FetchFormDataAPI();

          const updateFormValues = async () => {
            if (formConfig?.data?.data && formValues) {
              await mapFormCascadeOptionsNonAuthConfig(
                formConfig.data.data,
                formValues,
              ); // Ensure all async calls finish
            }
            setFetchFormData(formValues); // Now update the form
          };

          updateFormValues();
        }
        setFormData(formConfig);
      }
    } catch (error) {
      hideLoader();
      console.warn(error);
    } finally {
      await hideLoader();
    }
  };

  const FetchFormDataAPI = async () => {
    try {
      await showLoader();
      const FetchFormValues = await API.post(getFormValues, {
        InterfaceId: interfaceId,
        RId: RId,
        Mode: mode.toLowerCase() === "view" ? "Edit" : mode,
        ActionType: "DynamicFormActionFetch",
        FieldIds: "",
        FormData: `{"RId":${RId}, "TabId":${parseInt(activeTab)}, "RoleId":${commonContextParams?.roleId}}`,
      });
      if (FetchFormValues.data.data) {
        const SetSubTitle = FetchFormValues.data.data[0].data.SetSubTitle;
        if (SetSubTitle != null && SetSubTitle !== "0") {
          interfaceActionHandler["SetSubTitle"](SetSubTitle);
        }
      }
      return FetchFormValues.data.data;
    } catch (error) {
      console.error("Error:", error);
      return;
    } finally {
      await hideLoader();
    }
  };

  const getKeyLength = (obj?: any, targetKey?: string): number => {
    // NOSONAR : ignore
    if (!obj || typeof obj !== "object") return 0;

    if (targetKey) {
      if (targetKey in obj) {
        const value = obj[targetKey];

        if (value) {
          if (typeof value === "string") return value.length;
          if (Array.isArray(value)) return value.length;
          if (typeof value === "object") return Object.keys(value).length;
        }
      }

      for (const value of Object.values(obj)) {
        const length = getKeyLength(value, targetKey);
        if (length !== null) return length;
      }
    }

    return 0;
  };

  const convertMultiSelectFields = (
    obj: any,
    multiselectFields: string[],
  ): any => {
    if (Array.isArray(obj)) {
      return obj.map((item) =>
        convertMultiSelectFields(item, multiselectFields),
      );
    } else if (typeof obj === "object" && obj !== null) {
      return Object.keys(obj).reduce((acc: any, key: string) => {
        if (multiselectFields.includes(key) && obj[key]) {
          if (typeof obj[key] === "string") {
            const valuesArray = obj[key]
              ?.split(", ") // Split the string into an array of labels
              .map((label: string) => {
                let field = findFieldByName(key);
                if (field && field.fieldOptions.length > 0) {
                  const found = field.fieldOptions?.find(
                    (opt: { label: string }) => opt.label === label, // NOSONAR : ignore
                  );
                  return found?.value ?? null; // Get the corresponding value or null
                }
                return null;
              })
              .filter(Boolean); // Remove null values

            acc[key] = valuesArray.join(",");
          }
        } else {
          acc[key] = convertMultiSelectFields(obj[key], multiselectFields);
        }
        return acc;
      }, {});
    }
    return obj; // Return unchanged if not an object or array
  };

  const findFieldByName = (fieldName: string) => {
    let data = formData?.data ?? [];
    for (const item of data) {
      if (Array.isArray(item.content)) {
        const found = item.content.find(
          (field: { name: string }) => field.name === fieldName,
        );
        if (found) return found; // Return the first match found
      }
    }
    return null; // Return null if not found
  };

  //fieldset grids update function
  const handleFieldSetButtonClick = (
    action: string,
    fieldSetKey: string,
    formValue: any,
    targetIndex: number = -1,
  ) => {
    let multiSelectFields: any[] = []; // NOSONAR : ignore
    console.log(
      "formData",
      formData,
      "formValue",
      formValue,
      " action ",
      action,
      " fieldSetKey ",
      fieldSetKey,
    );
    if (formData.data) {
      let DataObj = formData.data?.data;
      console.log("formData in dynamic form", DataObj);
      DataObj?.forEach((element: { section: any; content: any }) => {
        let fields = [];
        if (element && element.section?.length > 0) {
          element.section.forEach((sect: { header: string; content: any }) => {
            if (sect.header !== "ActionConfig") {
              fields = sect.content;
              fields?.forEach((f: { name: any; type: string }) => {
                // NOSONAR : ignore
                if (
                  f.type?.toLowerCase() === "selectmulti" ||
                  f.type?.toLowerCase() === "select"
                ) {
                  console.log("Found multi-select field:811", f);
                  multiSelectFields.push(f.name);
                }
              });
            }
          });
        } else {
          fields = element.content;
          fields?.forEach((f: { name: any; type: string }) => {
            if (
              f.type?.toLowerCase() === "selectmulti" ||
              f.type?.toLowerCase() === "select"
            ) {
              multiSelectFields.push(f.name);
              console.log("Found multi-select field:825", f);
            }
          });
        }
      });
    }

    if (action === "Add") {
      let fieldSetLength = getKeyLength(gridData, fieldSetKey);
      const newKey = (fieldSetLength + 1).toString();

      setGridData((prev) => ({
        ...prev,
        [fieldSetKey]: [
          ...(prev[fieldSetKey] ?? []),
          { Id: newKey, ...formValue },
        ],
      }));
    } else if (action === "Update") {
      setGridData((prev) => ({
        ...prev,
        [fieldSetKey]: prev[fieldSetKey].map((item: any) =>
          item.Id === targetIndex ? { ...item, ...formValue } : item,
        ),
      }));
    } else if (action === "Delete") {
      setGridData((prev) => ({
        ...prev,
        [fieldSetKey]: prev[fieldSetKey].filter(
          (item: any) => item.Id !== targetIndex,
        ),
      }));
    }
  };

  //editablefieldset grids update function
  const handleEditableFieldSetButtonClick = (
    action: string,
    fieldSetKey: string,
    formValue: any,
    targetIndex: number = -1,
  ) => {
    let multiSelectFields: any[] = [];
    console.log("formData", formData);
    if (formData.data) {
      let DataObj = formData.data?.data;

      DataObj?.forEach((element: { section: any; content: any }) => {
        let fields = [];
        if (element && element.section?.length > 0) {
          element.section.forEach((sect: { header: string; content: any }) => {
            if (sect.header !== "ActionConfig") {
              fields = sect.content;
              fields?.forEach((f: { name: any; type: string }) => {
                // NOSONAR : ignore
                if (f.type?.toLowerCase() === "selectmulti") {
                  multiSelectFields.push(f.name);
                }
              });
            }
          });
        } else {
          fields = element.content;
          fields?.forEach((f: { name: any; type: string }) => {
            if (f.type?.toLowerCase() === "selectmulti") {
              multiSelectFields.push(f.name);
            }
          });
        }
      });
    }

    // 🔑 Normalize multi-select fields into comma-separated strings
    const normalizedFormValue: any = { ...formValue };
    console.log("Adding new entry to editable grid:", normalizedFormValue);
    Object.keys(formValue ?? {}).forEach((key) => {
      if (multiSelectFields.includes(key) && Array.isArray(formValue[key])) {
        normalizedFormValue[key] = formValue[key].join(", ");
      }
    });

    if (action === "Add") {
      // console.log("Adding new entry to editable grid:", normalizedFormValue);
      let fieldSetLength = getKeyLength(editablegridData, fieldSetKey);
      const newKey = (fieldSetLength + 1).toString();

      setEditableGridData((prev) => ({
        ...prev,
        [fieldSetKey]: [
          ...(prev[fieldSetKey] ?? []),
          { Id: newKey, ...normalizedFormValue },
        ],
      }));
    } else if (action === "Update") {
      setEditableGridData((prev) => ({
        ...prev,
        [fieldSetKey]: prev[fieldSetKey].map((item: any) =>
          item.Id === targetIndex ? { ...item, ...normalizedFormValue } : item,
        ),
      }));
    } else if (action === "Delete") {
      setEditableGridData((prev) => ({
        ...prev,
        [fieldSetKey]: prev[fieldSetKey].filter(
          (item: any) => item.Id !== targetIndex,
        ),
      }));
    }
  };

  const isResetAction = (button: any) =>
    button?.actionKey?.toLowerCase() === "dynamicformactionreset";

  const isCancelAction = (button: any) =>
    button?.actionKey?.toLowerCase() === "dynamicformactioncancel";

  const isSwitchTabAction = (button: any) =>
    button?.actionKey === "DynamicFormSaveAndSwitchTab";

  const isNextPrevSwitchTabAction = (button: any) =>
    button?.actionKey === "DynamicFormActionNextTab" ||
    button?.actionKey === "DynamicFormActionPrevTab";

  ////Added By Vishrant for save button logic for validation.
  const isSaveButtonAction = (button: any) =>
    button?.actionKey === "DynamicFormActionSave";

  const validateTabFields = async (form: any, formSections: any[]) => {
    let tabFields: any[] = [];

    formSections.forEach((fs: any) => {
      if (fs.header !== "ActionConfig") {
        fs.content.forEach((x: { name: any }) => tabFields.push(x.name));
      }
    });

    try {
      await form.validateFields(tabFields);
    } catch (error: any) {
      let errorFields = error.errorFields.map((x: any) => x.name).join(",");
      //message.error("Please fill these fields: " + errorFields);
      throw error;
    }
  };

  const normalizeFormValues = (formValue: any) => {
    console.log("Raw form values before normalization:", formValue);
    Object.keys(formValue).forEach((key) => {
      if (Array.isArray(formValue[key])) {
        if (formValue[key].every((x) => typeof x === "string")) {
          formValue[key] = formValue[key].join(",");
        } else if (
          formValue[key].every(
            (item: { name: any }) =>
              typeof item === "object" && item.name,
          )
        ) {
          return formValue[key]
            .map((file: { name: any }) => file.name)
            .join(","); // or keep as-is
        } else if (formValue[key].every((x) => x?.name)) {
          formValue[key] = formValue[key].map((f: any) => f.name).join(",");
        }
      } else if (formValue[key]?.$d) {
        formValue[key] = dayjs(formValue[key]).format("YYYY-MM-DD HH:mm:ss");
      }
    });

    return formValue;
  };

  const executeFunctionAction = async (
    execData: string,
    button: any,
    formValue: any,
    interfaceActionHandler: any,
  ) => {
    if (!interfaceActionHandler[execData]) {
      console.error(`No handler found for function: ${button.label}`);
      return null;
    }

    const result = await interfaceActionHandler[execData](button, formValue);
    if (!result) return null;

    const { data } = result;

    if (data?.status !== ApiStatus.OK &&
      data?.status !== ApiStatus.Success
    ) {
      message.error(
        //data?.errorCode === "DBVALIDATION" ? data.message : "Failed.",
        (data?.errorCode === "DB_VALIDATION" || data?.errorCode === "DBVALIDATION")
          ? data.message : "Failed.",
      );
      return null;
    }

    // OK success
    if (data?.message?.toLowerCase() === "ok" && data.data?.length > 0) {
      return data.data.reduce((acc: any, x: any) => {
        acc[x.key] = x.value;
        return acc;
      }, {});
    }

    // Validation errors
    if (data?.message?.toLowerCase() === "error") {
      const validationMessages = data.data
        .filter((x: any) => x.ErrorMessage?.length)
        .map((x: any) =>
          x.ErrorMessage.map(
            (err: string) => `${x.SectionName}: ${x.FieldName}: ${err}`,
          ),
        )
        .flat();

      if (validationMessages.length > 0) {
        notification.error({
          message: "Validation Error",
          description: (
            <div>
              {validationMessages.map((m: any) => (
                <div key={crypto.randomUUID()}>{m}</div>
              ))}
            </div>
          ),
        });
        return null;
      }
    }

    return null;
  };
  const executeDbAction = async (
    action: any,
    formValue: any,
    button: any,
    interfaceId: any,
  ) => {
    formValue.TabId = activeTab;
    const updateResponse = await API.post(executeAction, {
      InterfaceId: interfaceId,
      Mode:
        // button?.actionKey?.toLowerCase() === "dynamicformactionupdate"
        //   ? "Edit"
        //   : "Create",
        button?.actionKey?.toLowerCase() === "dynamicformactionupdate"
          ? "Edit"
          : button?.actionKey?.toLowerCase() === "dynamicformactionsave" ////Added By Vishrant for save button logic for validation.
            ? "All"
            : "Create",
      ActionType: button?.actionKey,
      ActionId: action.actionId,
      FieldIds: "",
      FormData: JSON.stringify(formValue),
    });

    //if (updateResponse.data.status !== 0) {
    if (updateResponse.data.status !== ApiStatus.OK &&
      updateResponse.data.status !== ApiStatus.Success
    ) {
      message.error(
        // updateResponse.data?.errorCode === "DBVALIDATION"
        //   ? updateResponse.data.message
        //   : "Failed.",
        (updateResponse.data?.errorCode === "DBVALIDATION" ||
          updateResponse.data?.errorCode === "DB_VALIDATION")
          ? updateResponse.data.message
          : "Failed.",
      );
      return null;
    }

    if (action.execType === "Query") return null;

    return updateResponse.data.data.reduce((acc: any, item: any) => {
      acc[item.key] = item.value;
      return acc;
    }, {});
  };
  const handleInterfaceActionClick = async (form: any, button: any) => {
    setButtonLoadings((p) => ({ ...p, [button.label]: true }));

    try {
      await showLoader();

      if (!button?.actions?.length && !isCancelAction(button)) {
        console.error(`No action found for ${button.label}`);
        return;
      }

      // RESET
      if (isResetAction(button)) {
        handleReset(form);
        return;
      }

      // CANCEL
      if (isCancelAction(button)) {
        handleCancel(form);
        return;
      }

      await processActions(button, form);
    } catch (error: any) {
      handleValidationErrors(error);
    } finally {
      await hideLoader();
      setButtonLoadings((p) => ({ ...p, [button.label]: false }));
    }
  };
  const handleReset = (form: any) => {
    form.resetFields();
    setResetUpload((p) => p + 1);
    setIsReset(true);
    // message.info("Form reset successfully.");
    setGridData(null);
    setEditableGridData([]);
  };

  const handleCancel = (form: any) => {
    form.resetFields();
    setResetUpload((p) => p + 1);
    setGridData(null);
    setEditableGridData([]);
    props.handleCancel?.();
  };

  const processActions = async (button: any, form: any) => {
    let actionResponse: any = null;
    let isSwitchTab = false;
    let hasDbValidationError = false;
    let hasFunction = false;
    let hasTabNavigateFunction = false;
    debugger
    for (const action of button.actions) {
      // if (action.execType !== "Function") {
      if (isSwitchTabAction(button)) {
        isSwitchTab = true;
        await validateTabFields(form, formSections);
      }
      ////Added By Vishrant for save button logic for validation.
      else if (isNextPrevSwitchTabAction(button)) {
        hasTabNavigateFunction = true;
      }
      else if (isSaveButtonAction(button)) {
        if (action?.execFieldValidation?.length > 0) {
          await form.validateFields(action?.execFieldValidation);
        }
      }
      else if (action.execType == "Function") {
        hasFunction = true;
        if (action?.execFieldValidation?.length > 0) {
          await form.validateFields(action?.execFieldValidation);
        } else {
          await validateTabFields(form, formSections);
        }
      }
      else {
        await validateTabFields(form, formSections);
        //await form.validateFields();
      }
      // } else {
      //   hasFunction = true;
      // }

      let rawFormValue = {
        ...form.getFieldsValue(),
        CreatedBy: commonContextParams.userId,
        ...commonContextParams,
        ...initialMaskValue,
        ...gridData,
        ...editablegridData,
        RId,
        ...actionResponse,
      };

      let formValue = normalizeFormValues({
        ...fetchedEditData,
        ...rawFormValue,
      });

      if (action.execType === "Function") {
        actionResponse = await executeFunctionAction(
          action.execData,
          button,
          formValue,
          interfaceActionHandler,
        );

        if (actionResponse === null) {
          hasDbValidationError = true;
          break;
        }

      } else {
        actionResponse = await executeDbAction(
          action,
          formValue,
          button,
          interfaceId,
        );
        if (actionResponse === null) {
          hasDbValidationError = true;
          break;
        }
      }
    }

    // if (!hasFunction) {
    if (hasDbValidationError) return;

    if (!isSwitchTab && !hasTabNavigateFunction) {

      if (!hasFunction) {
        message.success("Form Submitted successfully.");
      }
      props.onSuccess?.();
      form.resetFields();
      setResetUpload((p) => p + 1);
      props.handleCancel?.();
      // handleCancel();
      setGridData(null);
      setEditableGridData([]);
    }
    // }
  };

  const Handlecancelbutton = () => {
    setHideBtn(true);
  };

  const handleValidationErrors = (error: any) => {
    const errorFields =
      error?.errorFields?.map((x: any) => x.errors).flat() ?? [];

    const chunks = [];
    for (let i = 0; i < errorFields.length; i += 8) {
      chunks.push(errorFields.slice(i, i + 8).join(", "));
    }

    message.error({
      content: (
        <div>
          <div style={{ fontWeight: "bold" }}>Please fill these fields:</div>
          {chunks.map((c) => (
            <div key={crypto.randomUUID()}>{c}</div>
          ))}
        </div>
      ),
    });
  };

  const checkButtonIsLoading = (type: string) => {
    return buttonLoadings[type];
  };

  const saveSectionData = async (
    sectionName: string,
    sectionFieldsValue: any,
  ) => {
    let functionResult = await interfaceActionHandler["SaveSectionWiseDetails"](
      sectionName,
      sectionFieldsValue,
    );

    if (functionResult.data?.status != 0) {
      console.log("Data not saved.");
    } else if (
      functionResult.data.status == 0 &&
      functionResult.data.message.toLowerCase() == "ok"
    ) {
      console.log("Data saved.");
    }
  };

  // Move outside the nested block
  const extractSectionFieldValues = (formData: any, sectionContent: any[]) => {
    return sectionContent.reduce((acc: any, item: any) => {
      acc[item.name] = formData[item.name];
      return acc;
    }, {});
  };

  // NOSONAR : ignore
  const sectionContent = (section: any, index: number) => {
    // CASE 1: ActionConfig Section
    if (section?.header === "ActionConfig") {
      return (
        <div className="button-area" key={`action-${section._key}`}>
          <div className="button-section">
            {section?.content?.map((field: any, fieldIndex: number) => (
              <DynamicFormCase
                key={`action-field-${section.key}-${fieldIndex}`}
                field={field}
                form={form}
                keyIdentity={section.key}
                handleButtonClick={handleInterfaceActionClick}
                actionType={actionType}
                fields={[]}
                dataSource={[]}
                checkButtonIsLoading={checkButtonIsLoading}
                resetUpload={resetUpload}
                InterfaceId={interfaceId}
              />
            ))}
          </div>
        </div>
      );
    }

    // CASE 2: Collapsible Section
    if (section?.header) {
      return (
        <Collapse
          key={`collapse-${section._key}`}
          className="Collapse-container my-2 mx-0"
          defaultActiveKey="panel-0"
        >
          <Panel
            header={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div>{section.header}</div>
                <Button
                  className="save_ico"
                  type="text"
                  icon={<AntIcons.SaveOutlined />}
                  onClick={(e) => {
                    e.stopPropagation();
                    const sectionFields = section.content.map(
                      (x: any) => x.name,
                    );

                    form
                      .validateFields(sectionFields)
                      .then(() => {
                        const formData = form.getFieldsValue();
                        const sectionFieldValues = extractSectionFieldValues(
                          formData,
                          section.content,
                        );

                        saveSectionData(section.header, sectionFieldValues);
                      })
                      .catch((errorInfo: any) => {
                        console.log("Validation failed:", errorInfo);
                      });
                  }}
                />
              </div>
            }
            key={`panel-${section._key}`}
          >
            <Row gutter={16}>
              {section?.content?.map((field: any, fieldIndex: number) =>
                !field.parentId || field.parentId.toString() === "0" ? (
                  <DynamicFormCase
                    key={`collapse-field-${index}-${field.name}`}
                    field={field}
                    fields={section.content}
                    form={form}
                    docName={DocName}
                    keyIdentity={fieldIndex}
                    mode={mode.toLowerCase() === "view" ? "Edit" : mode}
                    handleButtonClick={handleInterfaceActionClick}
                    actionType={actionType}
                    dataSource={gridData ? gridData[field.name] : null}
                    handleFieldSetButtonClick={handleFieldSetButtonClick}
                    dataEditableSource={
                      editablegridData ? editablegridData[field.name] : null
                    }
                    handleEditableFieldSetButtonClick={
                      handleEditableFieldSetButtonClick
                    }
                    checkButtonIsLoading={checkButtonIsLoading}
                    resetUpload={resetUpload}
                    InterfaceId={interfaceId}
                  />
                ) : null,
              )}
            </Row>
          </Panel>
        </Collapse>
      );
    }

    // CASE 3: Plain Section
    return (
      <Row gutter={16} key={`row-${section._key}`}>
        {section?.content?.map((field: any, fieldIndex: number) =>
          field.parentId === 0 ? (
            <DynamicFormCase
              key={`plain-field-${index}-${field.name}`}
              field={field}
              fields={section.content}
              form={form}
              keyIdentity={fieldIndex}
              handleButtonClick={handleInterfaceActionClick}
              actionType={actionType}
              mode={mode.toLowerCase() === "view" ? "Edit" : mode}
              dataSource={gridData ? gridData[field.name] : null}
              handleFieldSetButtonClick={handleFieldSetButtonClick}
              dataEditableSource={
                editablegridData ? editablegridData[field.name] : null
              }
              handleEditableFieldSetButtonClick={
                handleEditableFieldSetButtonClick
              }
              checkButtonIsLoading={checkButtonIsLoading}
              docName={DocName}
              handleMaskValueChange={handleMaskValueChange}
              initialMaskValue={initialMaskValue}
              resetUpload={resetUpload}
              InterfaceId={interfaceId}
            />
          ) : null,
        )}
      </Row>
    );
  };

  return (
    <>
      {formSections?.length > 0
        ? formSections.map((section: any, index: number) =>
          section?.permissions?.length > 0 ||
            section?.header === "ActionConfig" ||
            section?.header === null
            ? sectionContent(section, index)
            : null,
        )
        : null}
    </>
  );
});

export default DynamicFormComponent;
